document.addEventListener('click', (event) => {
  const submitButton = event.target.closest('.product-form__submit[type="submit"]');
  if (!submitButton) return;

  const textSpan = submitButton.querySelector('span');
  if (!textSpan) return;

  // Do not run if the button is disabled
  if (submitButton.disabled || submitButton.getAttribute('aria-disabled') === 'true') return;

  // Change the text to added immediately
  textSpan.textContent = 'Added';
});
